<!--
 * @Author: 侯鹏许(houpengxu@qq.com)
 * @Date: 2019-12-23 23:09:18
 * @LastEditors: 诺
 * @LastEditTime: 2022-04-27 16:10:35
 * @Description: file content
 -->
<template>
  <div class="mymodal" v-show="value">
    <canvas class="canvas" id="canvas" width="300" height="508"></canvas>
    <img class="poster" :src="posterImg" alt />
    <div class="save">“长按图片，保存您的专属海报”</div>
    <img class="close" @click="clickClose" src="http://assets.rurushishi.com/activies/activityCenter/turntableLottery/close.png" alt />
  </div>
</template>

<script>
import Canvastoimg from "wtc-canvastoimg";
import QRCode from "qrcode";
export default {
  components: {},
  props: {},
  data() {
    return {
      value: false,
      title: "",
      callback: null,
      posterImg: "",
      qrcodeUrl: "", //https://assets.rurushishi.com/web1001/wxf1efeb9b9d6f6f06/1578572258000-45.png
      configInfo: {},
      imgSrc: "",
    };
  },
  watch: {
    value: function (newVal) {
      this.posterImg = "";
      if (newVal) {
        this.init();
      }
    },
  },
  computed: {},
  mounted() {
    this.configInfo =this.$configInfo ;
  },
  methods: {
    async  init() {
      if (!this.qrcodeUrl) {
        let tmpUrl = this.$util.cookie.get("shareLink");
        console.log("tmpUrl", tmpUrl);
        let url = this.$apizt.action.getShareUrl;
        const { data, result } = await this.$httpzt.requestRestFul(url, {shareUrl:tmpUrl});
        if (result) {
          QRCode.toDataURL(data).then((url) => {
            this.qrcodeUrl = url;
            // this.$showLoading();
            this.createImg();
          });
        }else{
          this.clickClose()
        }
      } else {
        // this.$showLoading();
        this.createImg();
      }
    },
    colorRgb(color, aplan) {
      // 16进制颜色值的正则
      var reg = /^#([0-9a-fA-f]{3}|[0-9a-fA-f]{6})$/;
      // 把颜色值变成小写
      color = color.toLowerCase();
      if (reg.test(color)) {
        // 如果只有三位的值，需变成六位，如：#fff => #ffffff
        if (color.length === 4) {
          var colorNew = "#";
          for (var i = 1; i < 4; i += 1) {
            colorNew += color.slice(i, i + 1).concat(color.slice(i, i + 1));
          }
          color = colorNew;
        }
        // 处理六位的颜色值，转为RGB
        var colorChange = [];
        for (var i = 1; i < 7; i += 2) {
          colorChange.push(parseInt("0x" + color.slice(i, i + 2)));
        }
        return "RGB(" + colorChange.join(",") + "," + aplan + ")";
      } else {
        return color;
      }
    },
    createImg() {
      let that = this;
      let scale = 5;
      let canvas = document.getElementById("canvas");
      console.log(canvas);
      canvas.width = 300 * scale;
      canvas.height = 508 * scale;
      if (canvas.getContext) {
        let ctx = canvas.getContext("2d");

        let img = new Image();
        img.onload = function () {
          ctx.drawImage(img, 0, 0, 300 * scale, 450 * scale);

          ctx.fillStyle = "#FFF";
          ctx.beginPath();
          ctx.moveTo(0, 426 * scale);
          ctx.lineTo(300 * scale, 450 * scale);
          ctx.lineTo(0, 428 * scale);
          ctx.fill();
          ctx.moveTo(0, 428 * scale);
          ctx.lineTo(300 * scale, 450 * scale);
          ctx.lineTo(300 * scale, 459 * scale);
          ctx.fill();

          ctx.fillStyle = "#FFF";
          ctx.beginPath();
          ctx.moveTo(0, 428 * scale);
          ctx.lineTo(300 * scale, 459 * scale);
          ctx.lineTo(0, 430 * scale);
          ctx.fill();
          ctx.moveTo(0, 430 * scale);
          ctx.lineTo(300 * scale, 459 * scale);
          ctx.lineTo(300 * scale, 468 * scale);
          ctx.fill();

          ctx.fillStyle = that.colorRgb(that.configInfo.mainColour, 0.5);
          ctx.beginPath();
          ctx.moveTo(0, 428 * scale);
          ctx.lineTo(300 * scale, 459 * scale);
          ctx.lineTo(0, 430 * scale);
          ctx.fill();
          ctx.moveTo(0, 430 * scale);
          ctx.lineTo(300 * scale, 459 * scale);
          ctx.lineTo(300 * scale, 468 * scale);
          ctx.fill();

          ctx.fillStyle = that.configInfo.mainColour;
          ctx.beginPath();
          ctx.moveTo(0, 430 * scale);
          ctx.lineTo(300 * scale, 468 * scale);
          ctx.lineTo(0, 468 * scale);
          ctx.fill();
          ctx.fillRect(0, 468 * scale, 300 * scale, 40 * scale);
          that.imgSrc = canvas.toDataURL("image/png");
          that.createImg2();
        };
        // let posterUrl = this.configInfo.shareImg;
        img.setAttribute("crossOrigin", "Anonymous");
        img.src = this.configInfo.shareImg;
      }
      // that.$hideLoading();
    },
    createImg2() {
      let posterUrl = this.imgSrc;
      console.log(posterUrl);
      /* 初始化类 */
      let sharpness = 3;
      let cvsImgData = [
        {
          type: "img",
          shape: "", //默认是矩形，  'arc代表画圆'
          zIndex: 1,
          x: 0,
          y: 0,
          width: 375 * sharpness,
          height: 622 * sharpness,
          content: posterUrl,
          // content: 'https://assets.rurushishi.com/activies/activityCenter/turntableLottery/bg.png',
        },
        {
          type: "img", //二维码
          zIndex: 2,
          x: 235 * sharpness,
          y: 502.5 * sharpness,
          width: 100 * sharpness,
          height: 100 * sharpness,
          content: this.qrcodeUrl,
        },
        {
          type: "text",
          zIndex: 3,
          fontSize: `bold ${18 * sharpness}px 微软雅黑`,
          x: 40 * sharpness,
          y: 556 * sharpness,
          content: "分享海报",
          color: "#ffffff",
        },
        {
          type: "text",
          zIndex: 3,
          fontSize: `${14 * sharpness}px 微软雅黑`,
          x: 40 * sharpness,
          y: 584 * sharpness,
          content: "获得更多机会和奖励",
          color: "#ffffff",
        },
      ];

      const cvsimg = new Canvastoimg({
        width: 375 * sharpness, //画布宽度
        height: 622 * sharpness, //画布高度
        color: "transparent", //画布背景色
        data: cvsImgData,
      });
      cvsimg.down().then((canvas) => {
        /* 获取到的是canvas对象 */
        this.$hideLoading();
        this.posterImg = canvas.toDataURL("image/jpg");
      });
    },
    clickClose() {
      this.value = false;
      this.callback("cancel");
    },
  },
  created() {},
};
</script>
<style lang="stylus" scoped>
.mymodal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.8);
  color: #ffffff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.msgbox {
  width: 100%;
  height: 100vh;
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.poster {
  border-radius: 12px;
  max-height: calc(100vh - 108px);
  max-width: 80%;
  height :auto;
}

.canvas {
  top: -9999px;
  left: -9999px;
  position: absolute;
}

.save {
  font-size: 15px;
  line-height: 18px;
  font-family: PingFang SC;
  color: rgba(255, 255, 255, 1);
  margin-top: 15px;
  text-align: center;
}

.close {
  width: 40px;
  margin-top: 15px;
}

.back {
  width: 100px;
  height: 32px;
  border-radius: 5px;
  font-size: 18px;
  font-family: PingFang;
  font-weight: bold;
  margin-top: 15px;
  text-align: center;
  line-height: 32px;
}
</style>
